import {
  Brain,
  Briefcase,
  Building2,
  ChartBar,
  ChartLine,
  CircleDollarSign,
  Cog,
  Crown,
  Database,
  DollarSign,
  Flag,
  Globe,
  Handshake,
  Heart,
  Lightbulb,
  type LucideIcon,
  Monitor,
  Package,
  Puzzle,
  Rocket,
  Shield,
  Star,
  Target,
  TrendingUp,
  Trophy,
  UserCheck,
  Users,
  Zap,
} from "lucide-react";

/**
 * Curated list of icons, in order to allow folks to pick one in the KPI Editor.
 */
export const AVAILABLE_ICONS: Record<string, LucideIcon> = {
  // Strategy & Leadership
  brain: Brain,
  crown: Crown,
  flag: Flag,
  lightbulb: Lightbulb,
  rocket: Rocket,
  target: Target,
  trophy: Trophy,

  // People & Teams
  handshake: Handshake,
  "user-check": UserCheck,
  users: Users,

  // Business & Finance
  briefcase: Briefcase,
  "building-2": Building2,
  "circle-dollar-sign": CircleDollarSign,
  "dollar-sign": DollarSign,
  "trending-up": TrendingUp,

  // Technology & Data
  cog: Cog,
  database: Database,
  monitor: Monitor,
  zap: Zap,

  // Products & Operations
  globe: Globe,
  package: Package,
  puzzle: Puzzle,
  shield: Shield,

  // Metrics & Performance
  "chart-bar": ChartBar,
  "chart-line": ChartLine,
  star: Star,

  // Other
  heart: Heart,
};

export type IconName = keyof typeof AVAILABLE_ICONS;

export function getIcon(name: string | null | undefined): LucideIcon | null {
  if (!name) return null;
  return AVAILABLE_ICONS[name] ?? null;
}
